import styled from 'styled-components';

export const StyledChatCard = styled.div`
	min-width: 700px;
	width: 700px;
	min-height: 400px;
	padding: 40px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
	border-radius: 20px;
	background: #fff;
	flex-shrink: 0;
	scroll-snap-align: center;

	/* Entrance animation */
	animation: slideInFromRight 0.6s cubic-bezier(0.4, 0, 0.2, 1);

	@keyframes slideInFromRight {
		from {
			opacity: 0;
			transform: translateX(50px) scale(0.95);
		}
		to {
			opacity: 1;
			transform: translateX(0) scale(1);
		}
	}
`;

export const ChatContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

export const ChatHeader = styled.div`
	text-align: center;
	margin-bottom: 20px;
`;

export const MessagesContainer = styled.div`
	flex: 1;
	border: 1px solid #e5e7eb;
	border-radius: 12px;
	padding: 12px;
	background: #fff;
	margin-bottom: 12px;
	max-height: 300px;
	overflow-y: auto;
`;

export const MessageRow = styled.div<{ isUser: boolean }>`
	margin-bottom: 10px;
	display: flex;
	justify-content: ${props => (props.isUser ? 'flex-end' : 'flex-start')};
`;

export const MessageBubble = styled.div<{ isUser: boolean }>`
	max-width: 85%;
	padding: 10px 12px;
	border-radius: 12px;
	background: ${props => (props.isUser ? '#eef2ff' : '#f3f4f6')};
	border: 1px solid #e5e7eb;
	white-space: pre-wrap;
`;

export const MessageSender = styled.strong`
	display: block;
	margin-bottom: 4px;
`;

export const InputContainer = styled.div`
	display: flex;
	gap: 8px;
	position: relative;
	z-index: 1000;
`;

export const ChatTextarea = styled.textarea<{ disabled?: boolean }>`
	flex: 1;
	padding: 10px;
	border-radius: 12px;
	border: 1px solid #e5e7eb;
	resize: vertical;
	font-size: 14px;
	font-family: inherit;
	outline: none;
	background-color: ${props => (props.disabled ? '#f3f4f6' : '#ffffff')};
	position: relative;
	z-index: 1001;
	pointer-events: auto;

	&:focus {
		border-color: #1877f2;
	}
`;
